import { setStatus } from '../../search-and-filter-schema/protected';
const updateStatusFilter = (filters, filterValue) => {
  return setStatus(filterValue, filters);
};
export default updateStatusFilter;